import React, { useEffect, useState } from "react";
import SourceCard from "../components/sections/SourceCard";
import { Link } from "react-router-dom";
import HelmetWrapper from "../components/sections/HelmetWrapper";
import { analystMetaData } from "../seo/metaDeta";

let Connectors = [
  {
    name: "Mixpanel",
    img: require("../assets/images/connectors/mixpanel.png"),
    isAlpha: false,
    link: "",
    category: "",
  },
  {
    name: "Amplitude",
    img: require("../assets/images/connectors/amplitude.png"),
    isAlpha: false,
  },
  {
    name: "PostHog",
    img: require("../assets/images/connectors/posthog.png"),
    isAlpha: false,
  },
  {
    name: "PostgreSQL",
    img: require("../assets/images/connectors/postgresql.png"),
    isAlpha: false,
  },
];

const EmbedAnalytics = () => {
  const [ready, setReady] = useState(false);
  useEffect(() => {
    setTimeout(() => {
      setReady(true);
    }, 600);
  }, []);
  return (
    <>
      <HelmetWrapper {...analystMetaData} />
      <div className="container embed-box">
        <div className="top-box">
          <div className="heading-box">
            <div className="use__text-tag">Embedded analytics Demo</div>
            <div className="use__text-heading">
              Embedded Daily <br /> Website Traffic <br /> Analytics
            </div>
            <div className="use__text-sub">
              Discover insights on web traffic from GA4
            </div>
          </div>
          <img
            className="use__background"
            src={require("../assets/images/embed-analytic.svg")}
            alt="case"
          />
        </div>
        <div className="divider" />
        <div className="use__text-sub">
          Embedded Dashboards provide a way to bring insightful data analytics
          directly into your web application. The Embedded SDK allows you to
          embed superset dashboards into your own web app, using your app’s
          authentication. Embedding is done by inserting an iframe, containing a
          dashboard page, into the host application. There should be no need to
          log in to an integrated dashboard if the user is already logged in to
          the Host App.
        </div>
        <div className="embed-reports">
          <div className="use__card-heading">Reports Snapshot</div>
          <div className="reports">
            <iframe
              height={"800px"}
              width={"100%"}
              frameBorder={0}
              src={
                ready
                  ? "https://app.dznew.datazip.io/superset/dashboard/22/?native_filters_key=bI6CA7TGLi7wSquDWNunRRenN7OE2wyrz4b9HUfVhK3JE2HkODQOo91CmYtpmjUt&standalone=true"
                  : "about:blank"
              }
              title="google_analytics"
              loading="lazy"
            ></iframe>
          </div>
        </div>
        <div className="embed_benifits">
          <div className="use__card-heading">
            Benefits of embedded analytics
          </div>
          <div className="text-sub">Seamless user experience</div>
          <div className="use__text-sub">
            Embedded analytics allows for a seamless blend of analytics into
            your own web portal or application, making it easier for your users
            to adopt new analytics capabilities and improve their user
            experience.
          </div>
          <div className="text-sub">Create additional revenue streams</div>
          <div className="use__text-sub">
            By differentiating product offering, businesses can create
            additional revenue streams through up selling embedded analytics
            capabilities to their users.
          </div>
          <div className="text-sub">Deeper insights</div>
          <div className="use__text-sub">
            Through machine learning and ad-hoc capabilities (e.g., building
            custom dashboard and reports), embedded analytics allows businesses
            to self-serve and generate deeper insights for their users.
          </div>
        </div>
        <div className="integration__box">
          <div className="integration__box-heading">
            Connect your data in minutes
          </div>
          <div className="integration__box-connector">
            {Connectors.map((item, index) => {
              return <SourceCard source={item} key={index} />;
            })}
          </div>
          <Link to={"/onestack-data/connectors"}>
            <button className="integration__box-button">
              See all integrations
            </button>
          </Link>
        </div>
        <div className="divider" />
        <div className="use__freeTrial">
          <div className="freeTrial__textbox">
            <div className="freeTrial__textbox-1">
              All teams can benefit from centralized and reliable data
            </div>
            <div className="freeTrial__textbox-2">
              Start your free trial today
            </div>
            <div className="freeTrial__elipse"></div>
          </div>
          <div className="freeTrial__cta">
            <a
              href="https://calendly.com/d/dx2-qrw-g8j/hello-datazip"
              target="_blank"
              rel="noopener noreferrer"
            >
              <button className="freeTrial__cta-common freeTrial__cta-1">
                Get Started
              </button>
            </a>
            {/* <Link to={"/onestack-data/login"}>
              <button className="button__main button__tertiary">
                Access Sandbox
              </button>
            </Link> */}
          </div>
        </div>
      </div>
    </>
  );
};

export default EmbedAnalytics;
